import styled, { css } from 'styled-components';

// CONSTANTS
import { responsiveEndPoints } from '../../constants/responsive-endpoints';
import { theme } from '../../constants/theme';

// ENUMS
import { Alignments } from '../../enums/alignments';
import { Sizes } from '../../enums/sizes';
import { ToastThemes } from '../../enums/toastThemes';

// INTERFACES
import { IToastProps } from '../../interfaces/Toast.interface';

export const Container = styled.div<IToastProps>`
  display: inline-flex;
  align-items: center;
  min-height: 66px;
  padding: 16px 27px 16px 24px;
  position: fixed;
  opacity: 0;
  transition: opacity 0.65s;
  box-sizing: border-box;
  border-radius: 6px;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.regular};
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  z-index: 9999;

  @media (max-width: ${responsiveEndPoints.mobile}px) {
    flex-direction: column;
    width: 80vw;
    height: auto;
  }

  justify-content: space-between;  
  ${({ active }) =>
    active &&
    `
    opacity: 1;
  `}
${({ size }) =>
  size == Sizes.BIG &&
  css`
    width: 867px;
    height: 92px;
  `}  
  ${({ align }) =>
    align == Alignments.LEFT_TOP &&
    `
    left: 20px;
    top: 20px;
  `}
  ${({ align }) =>
    align == Alignments.RIGHT_TOP &&
    `
    right: 20px;
    top: 20px;
  `}
  ${({ align }) =>
    align == Alignments.LEFT_BOTTOM &&
    `
    left: 20px;
    bottom: 20px;
  `}
  ${({ align }) =>
    align == Alignments.RIGHT_BOTTOM &&
    `
    right: 20px;
    bottom: 20px;
  `}
  ${({ align }) =>
    align == Alignments.CENTER_BOTTOM &&
    `
    left: 0;
    right: 0;
    margin: auto;
    bottom: 20px;
  `}  
  ${({ themeProp }) =>
    themeProp == ToastThemes.LIGHT &&
    `
    color: ${theme.colors.secondary.gray100};
    background: ${theme.colors.primary.white};
    border: 1px solid ${theme.colors.secondary.gray600};
  `}
  ${({ themeProp }) =>
    themeProp == ToastThemes.DARK &&
    `
    color: ${theme.colors.primary.white};
    background: ${theme.colors.primary.black};
    border: 1px solid ${theme.colors.primary.black};
    box-shadow: 0px 34px 30px -20px rgba(0, 0, 0, 0.1);
  `}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const IconWrapper = styled.div<IToastProps>`
  display: block;
  margin-right: 24px;
  svg {
    display: block;
  }
  svg {
    rect {
      ${({ themeProp, actionToast }) =>
        themeProp == ToastThemes.LIGHT &&
        !actionToast &&
        `
        stroke: ${theme.colors.primary.black};
    `}
      ${({ themeProp, actionToast }) =>
        themeProp == ToastThemes.DARK &&
        !actionToast &&
        `
        stroke: ${theme.colors.primary.white};
    `}
    }
    path {
      ${({ themeProp, actionToast }) =>
        themeProp == ToastThemes.LIGHT &&
        !actionToast &&
        `
        fill: ${theme.colors.primary.black};
    `}
      ${({ themeProp, actionToast }) =>
        themeProp == ToastThemes.DARK &&
        !actionToast &&
        `
        fill: ${theme.colors.primary.white};
    `}
    }
  }
`;

export const Action = styled.div`
  display: flex;
  align-items: center;
  margin-left: 27px;
`;

export const ActionLabel = styled.label`
  display: block;
  margin-right: 10px;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  color: ${theme.colors.secondary.red100};
  cursor: pointer;
`;

export const ActionIcon = styled.div<IToastProps>`
  cursor: pointer;
  @media (max-width: ${responsiveEndPoints.mobile}px) {
    padding-top: 2vh;
  }
  svg {
    path {
      ${({ themeProp }) =>
        themeProp == ToastThemes.LIGHT &&
        `
        fill: ${theme.colors.primary.bariBlue};
    `}
      ${({ themeProp, actionLabel }) =>
        (themeProp == ToastThemes.DARK || actionLabel != null) &&
        `
        fill: ${theme.colors.secondary.red100};
    `}
    }
  }
`;
